module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor05.9a0631d2.png";